const resource = 'configurations'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  getPublic(id, params) {
    return $axios.$get(`/${resource}/public/${id}`, { params })
  },
  fetchPublicV2(identifier) {
    return $axios.$get(`/v2/configuration/${identifier}`)
  },
  update(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  delete(id) {
    return $axios.$delete(`/${resource}/${id}`)
  },

  getServiceName: name => 'configurationService',
})
